import { createBrowserClient } from '@impacta/shared/supabase/client';

export function createClient() {
  return createBrowserClient();
}
